export function initFooterFitText() {
    var statements = Array.from(document.querySelectorAll(".main-footer__statement"));
    if (!statements.length) return;

    var MIN_FONT_SIZE = 53;
    var MAX_FONT_SIZE = 118;
    var MOBILE_MIN_FONT_SIZE = 32;
    var MOBILE_MAX_FONT_SIZE = 118;
    var desktopQuery = window.matchMedia("(min-width: 768px)");
    var resizeFrame = null;

    function fit(el) {
        var firstWord = el.querySelector("p span");

        // Mobile sizes the whole statement off the first word, so it always spans the
        // full available width and the rest of the sentence scales along with it.
        if (!desktopQuery.matches) {
            if (!firstWord) {
                el.style.fontSize = "";
                return;
            }

            firstWord.style.fontSize = MOBILE_MAX_FONT_SIZE + "px";
            var containerWidth = el.clientWidth;
            var textWidth = firstWord.scrollWidth;
            firstWord.style.fontSize = "";
            if (!containerWidth || !textWidth) {
                el.style.fontSize = "";
                return;
            }

            var mobileFontSize = MOBILE_MAX_FONT_SIZE * (containerWidth / textWidth);
            mobileFontSize = Math.min(MOBILE_MAX_FONT_SIZE, Math.max(MOBILE_MIN_FONT_SIZE, mobileFontSize));
            el.style.fontSize = mobileFontSize + "px";
            return;
        }

        if (firstWord) firstWord.style.fontSize = "";

        var container = el.parentElement;
        if (!container) return;

        el.style.fontSize = MAX_FONT_SIZE + "px";
        var containerWidth = container.clientWidth;
        var textWidth = el.scrollWidth;
        if (!containerWidth || !textWidth) return;

        var fontSize = MAX_FONT_SIZE * (containerWidth / textWidth);
        fontSize = Math.min(MAX_FONT_SIZE, Math.max(MIN_FONT_SIZE, fontSize));
        el.style.fontSize = fontSize + "px";
    }

    function fitAll() {
        statements.forEach(fit);
    }

    function scheduleFit() {
        if (resizeFrame) return;
        resizeFrame = requestAnimationFrame(function () {
            resizeFrame = null;
            fitAll();
        });
    }

    fitAll();

    window.addEventListener("resize", scheduleFit);

    if (desktopQuery.addEventListener) {
        desktopQuery.addEventListener("change", fitAll);
    } else if (desktopQuery.addListener) {
        desktopQuery.addListener(fitAll);
    }

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(fitAll);
    }
}
